module.exports = function() {
  return new Worker(__webpack_public_path__ + "2f4ddc992e35c7c1d232.worker.js");
};